import { Dispatch, SetStateAction } from "react";
import { Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { DeleteFileExpandData } from "Services/PGXLis/ResultUpload";
import useLang from "Shared/hooks/useLanguage";

function DeleteModal({
  show,
  setShow,
  selectedRecord,
  refetch,
}: {
  setShow: Dispatch<SetStateAction<boolean>>;
  show: boolean;
  selectedRecord: number;
  refetch: () => Promise<unknown>;
}) {
  const { t } = useLang();

  const ModalhandleClose = () => setShow(false);

  const deleteMutation = useMutation({
    mutationFn: async (rawDataId: number) => {
      const res = await DeleteFileExpandData(rawDataId);
      return res.data;
    },
    onSuccess: (response) => {
      if (response.statusCode === 200) {
        toast.success(response.message);
        setShow(false);
        refetch();
      }
    },
  });

  return (
    <Modal
      show={show}
      onHide={ModalhandleClose}
      backdrop="static"
      keyboard={false}
      className="d-flex align-item-center"
      dialogClassName="no-shadow-modal-content"
    >
      <Modal.Header closeButton className="py-4 bg-light-primary">
        <Modal.Title className="h5">{t("Delete Record")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("Are you sure you want to delete this record ?")}
      </Modal.Body>
      <Modal.Footer className="py-2">
        <button
          id="PGXResultFileModalDeleteCancel"
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={ModalhandleClose}
        >
          {t("Cancel")}
        </button>
        <button
          id="PGXResultFileModalDeleteSave"
          type="button"
          className="btn btn-sm btn-danger"
          onClick={() => deleteMutation.mutate(selectedRecord)}
        >
          {t("Delete")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
